import React, { forwardRef } from 'react';
import { Check } from 'lucide-react';

const Checkbox = forwardRef(
  ({ label, checked, onChange, disabled = false, className = '', id, ...props }, ref) => {
    const checkboxId = id || (label ? `cb-${label.replace(/\s+/g, '-').toLowerCase()}` : undefined);
    return (
      <label
        htmlFor={checkboxId}
        className={`inline-flex items-center gap-2 cursor-pointer select-none ${
          disabled ? 'opacity-50 cursor-not-allowed' : ''
        } ${className}`}
      >
        <span className="relative inline-flex">
          <input
            ref={ref}
            id={checkboxId}
            type="checkbox"
            checked={!!checked}
            onChange={onChange}
            disabled={disabled}
            className="peer sr-only"
            {...props}
          />
          <span
            className="w-5 h-5 rounded border-2 border-gray-300 bg-white
              peer-checked:bg-primary peer-checked:border-primary
              peer-focus-visible:ring-2 peer-focus-visible:ring-primary peer-focus-visible:ring-offset-1
              transition-colors inline-flex items-center justify-center"
          >
            {checked && <Check size={14} className="text-white" strokeWidth={3} />}
          </span>
        </span>
        {label && <span className="text-sm text-app-text">{label}</span>}
      </label>
    );
  }
);

Checkbox.displayName = 'Checkbox';

export default Checkbox;
